import { render, staticRenderFns } from "./account_add_edit.vue?vue&type=template&id=66c7cff8&scoped=true&"
import script from "./account_add_edit.vue?vue&type=script&lang=js&"
export * from "./account_add_edit.vue?vue&type=script&lang=js&"
import style0 from "./account_add_edit.vue?vue&type=style&index=0&id=66c7cff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c7cff8",
  null
  
)

export default component.exports